
<div class="container-fluid webView" id="balancesheet">
    <!-- Header -->
    <div class="row"> 
        <div class="col-md-12" style="text-align: center;margin-top: 20px;">
            <span style="font-size: 20px">{{AgencyName}}</span><br>
            <span style="font-size: 18px; font-weight: bold;">Balance Sheet</span><br>
            <label style="font-weight: normal;">{{toDate}}</label>
        </div>
    </div>
    
     <!-- Body -->
     <div class="row marginZero" style="padding: 0px 20px;">
        <div class="col-md-12 mainCard table-bordered" style="padding: 0px !important;border-radius: 10px;border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;">
            <!-- Left -->
            <div class="col-md-6 col-6 mainCardHeader"
                style="display: inline-block; border-right: 1px solid #ddd; padding: 0px; vertical-align: top;">
                <div class="col-md-12"
                    style="text-align: center; border-bottom: 1px solid #ddd; background-color: #f5f5f5; border-top-left-radius: 10px; padding: 10px;">
                    Liabilities & Equity
                </div>
                <div class="col-md-12" *ngFor="let Heads of BindRecordLeft; let i = index"
                    style="font-size: 18px !important;">
                    <div style="margin-bottom: 10px; margin-top: {{i == 0 ? '10px' : ''}};"
                        *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <a style="font-weight: bold; cursor: pointer; color: rgb(232, 132, 33); text-decoration: none;" target="_blank"
                            [routerLink]="['/accounts', {id: Heads.HeadID, h:1, fdt: fromDate, tdt: toDate}]">{{Heads.HeadName}}</a>&nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{Heads.CloBal | cRDB}}</span>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;" *ngIf="expand">
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubHead of Heads.SubHead">
                                <div *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <a style="cursor: pointer; color: rgb(31, 98, 142); text-decoration: none;" target="_blank"
                                        [routerLink]="['/accounts', {id: SubHead.HeadID, h:1, fdt: fromDate, tdt: toDate}]">{{SubHead.HeadName}}</a>
                                    <span class="pull-right"><span style="font-family: Arial;">₹</span>{{SubHead.CloBal
                                        | cRDB}}</span>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubLedger of Heads.Ledger">
                                <div *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <a style="cursor: pointer; font-style: italic; color: #4caf50; text-decoration: none;" target="_blank"
                                        [routerLink]="['/accounts', {id: SubLedger.LedgerID, h:0, fdt: fromDate, tdt: toDate}]">{{SubLedger.LedgerName}}</a>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{SubLedger.CloBal | cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" *ngIf="profitLoss.length == 0" style="font-size: 18px !important;">
                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss > 0">
                        <span style="font-weight: bold;">Current Profit</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB}} </span>
                    </div>
                </div>

                <div class="col-md-12" *ngFor="let param of profitLoss" style="font-size: 18px !important;">
                    <div *ngIf="profitLoss.length > 0 && param.totalProfitAndLoss < 0">
                        <div ng-click="goToPAndL();" style="cursor: pointer;">
                            <span style="font-weight: bold;">{{param.LedgerName}}</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{param.totalProfitAndLoss | cRDB}}</span>
                        </div>
                        <div class="col-md-12" *ngIf="collapsed" style="padding-right: 0px; margin-bottom: 10px;">
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                <span>Opening Balance</span>
                                <span class="pull-right"><span
                                        style="font-family: Arial;">₹</span>{{param.openingProfitAndLoss | cRDB}}</span>
                            </div>
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                <span>Current Period</span>
                                <span class="pull-right"><span
                                        style="font-family: Arial;">₹</span>{{param.currentProfitAndLoss | cRDB}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" *ngFor="let Stock of AccurateProfitOrLoss" style="font-size: 18px !important;">
                    <div style="margin-bottom: 10px;" [hidden]="Stock.AccruedProfit == 0">
                        <span style="font-weight: bold;">Accrued Profit</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{Stock.AccruedProfit | cRDB}}</span>
                    </div>
                </div>


            </div>
            <!-- Right -->
            <div class="col-md-6 col-6 mainCardHeader"
                style="display: inline-block; border-left: 1px solid #ddd; padding: 0px; vertical-align: top;">
                <div class="col-md-12"
                    style="text-align: center; border-bottom: 1px solid #ddd; background-color: #f5f5f5; border-top-right-radius: 10px; padding: 10px;">
                    Assets
                </div>
                <div class="col-md-12" *ngFor="let Heads of BindRecordRight; let i = index"
                    style="font-size: 18px !important;">
                    <div style="margin-bottom: 10px; margin-top: {{i == 0 ? '10px' : ''}};"
                        *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <a style="font-weight: bold; cursor: pointer; color: rgb(232, 132, 33); text-decoration: none;" target="_blank"
                            [routerLink]="['/accounts', {id: Heads.HeadID, h:1, fdt: fromDate, tdt: toDate}]">{{Heads.HeadName}}</a>&nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{Heads.CloBal | cRDB}}</span>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;" *ngIf="expand">
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubHead of Heads.SubHead">
                                <div *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <a style="cursor: pointer; color: rgb(31, 98, 142); text-decoration: none;" target="_blank"
                                        [routerLink]="['/accounts', {id: SubHead.HeadID, h:1, fdt: fromDate, tdt: toDate}]">{{SubHead.HeadName}}</a>
                                    <span class="pull-right"><span style="font-family: Arial;">₹</span>{{SubHead.CloBal
                                        | cRDB}}</span>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubLedger of Heads.Ledger">
                                <div *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <a style="cursor: pointer; font-style: italic; color:#4caf50; text-decoration: none;" target="_blank"
                                        [routerLink]="['/accounts', {id: SubLedger.LedgerID, h:0, fdt: fromDate, tdt: toDate}]">{{SubLedger.LedgerName}}</a>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{SubLedger.CloBal | cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" *ngIf="profitLoss.length == 0" style="font-size: 18px !important;">
                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss < 0">
                        <span style="font-weight: bold;">Current Loss</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB}}</span>
                    </div>
                </div>

                <div class="col-md-12" *ngFor="let param of profitLoss" style="font-size: 18px !important;">
                    <div *ngIf="profitLoss.length > 0 && param.totalProfitAndLoss > 0">
                        <div style="margin-bottom: 10px; cursor: pointer;" ng-click="goToPAndL();">
                            <span style="font-weight: bold;">{{param.LedgerName}}</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{param.totalProfitAndLoss | cRDB}}</span>

                            <div class="col-md-12" ng-show="collapsed" style="padding-right: 0px; margin-bottom: 10px;">
                                <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                    <span>Opening Balance</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{param.openingProfitAndLoss |
                                        cRDB}}</span>
                                </div>
                                <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;">
                                    <span>Current Period</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{param.currentProfitAndLoss |
                                        cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" *ngFor="let Stock of AccurateProfitOrLoss" style="font-size: 18px !important;">
                    <div style="margin-bottom: 10px; cursor: pointer;" ng-click="goToStockSummary()"
                        *ngIf="(Stock.ClosingStock != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <span style="font-weight: bold;">Stock</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span style="font-family: Arial;">₹</span>
                            {{Stock.ClosingStock | cRDB}}</span>
                    </div>
                    <div style="margin-bottom: 10px;" [hidden]="Stock.AccruedLoss == 0">
                        <span style="font-weight: bold;">Accrued Loss</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{Stock.AccruedLoss | cRDB}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 table-bordered"
            style="padding-left: 0px; padding-right: 0px; border-top: none; margin-bottom: 10px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; font-size: 18px; border: 1.5px solid #ddd;"
            id="MainDiv1">
            <div class="col-md-6 col-6"
                style="border-right: 1px solid #ddd; padding-left: 0px; padding-right: 0px; display: inline-block;">
                <div class="col-md-12" style="padding-top: 10px; padding-bottom: 3px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">Total</span>
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{leftBal | cRDB}}</span>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-6" style="padding-left: 0px; padding-right: 0px; display: inline-block;">
                <div class="col-md-12" style="padding-top: 10px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">Total</span>
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{rightBal | cRDB}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>



